<template>
  <ReportTableWithHeader
    :loading="isLoading"
    :downloading="isDownloading"
    :rows="rows"
    :columns="columns"
    :page="page"
    :per-page="perPage"
    :page-size="pageSize"
    :total-page="totalPage"
    :total-records="totalRecords"
    downloadable
    :type="reportType"
    :form="form"
    @onFilter="onFilter"
    @onPageChange="onPageChange"
    @onPerPageChange="onPerPageChange"
    @onDownload="onDownload"
  />
</template>

<script>
import reportTableMixin from '@/mixins/reportTableMixin';

export default {
  mixins: [reportTableMixin],

  data() {
    return {
      columns: [
        { field: 'account' },
        { field: 'userName' },
        { field: 'startDate' },
        { field: 'endDate' },
        { field: 'interestRate' },
        { field: 'amount' },
        { field: 'payAmount' },
        { field: 'rateAmount' },
        { field: 'increaseRateAmount' },
        { field: 'hurRate' },
        { field: 'undsenRate' },
        { field: 'overdueDay' },
        { field: 'loanStatus' },
        { field: 'loanStatusOfCentralBank' },
        { field: 'officerName' },
      ],
      reportType: 'overdueLoan',
    };
  },

  methods: {
    updateFilters(data) {
      data.filters[`filter[status]`] = 'OVERDUE';
      data.filters[`filter[reportType]`] = this.reportType;
    },
  },
};
</script>
